import { useEffect } from 'react';
const PIXEL_ID = '1382813637335014';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}

/**
 * Meta Pixel (Facebook Pixel) base code + PageView.
 */
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const n: any = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    window._fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-31" data-mp="18eymnr5eg9i1">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-32" data-mp="18gjgfejw3oeu" />
    </noscript>;
}